import type { AlienGlobalSection } from './types';

/**
 * Promo Beacon — global Alien Invasion reference (not scenario-bound).
 * Visible whenever the expansion is enabled.
 */
export const alienInvasionBeacon: AlienGlobalSection = {
  id: 'ai:reference:beacon',
  title: 'Beacon',
  summary:
    'Projekt poziomu 3 dla generatora. Przy pozyskaniu daje 1 baterię. Pasujący naukowiec: R&D Engineer.',
  paragraphs: [
    'Projekt poziomu 3 dla generatora. Przy pozyskaniu daje 1 baterię. Pasujący naukowiec: R&D Engineer.',
  ],
  bullets: [
    'Ulepsz 1 budynek zgodnie ze zwykłymi zasadami, z możliwością użycia technologii.',
    'Albo zbuduj dowolny budynek; technologia jest wymagana przy tworzeniu lub powiększaniu kompleksu.',
    'Akcji nie można wzmacniać kolonistami.',
  ],
  searchKeywords: [
    'beacon',
    'beacon promo',
    'projekt',
    'blueprint',
    'generator',
    'bateria',
    'battery',
    'R&D Engineer',
    'zaawansowany budynek',
    'advanced building',
  ],
  relatedSectionIds: [],
};

export const alienInvasionGlobalSections: AlienGlobalSection[] = [
  alienInvasionBeacon,
];

export function getAlienInvasionGlobalSection(
  sectionId: string
): AlienGlobalSection | undefined {
  return alienInvasionGlobalSections.find((section) => section.id === sectionId);
}
